import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { useParams, useNavigate, useSearchParams } from "react-router-dom";

import { resolveVistaCursoAdminExitPath } from "../../../../utils/vistaCursosAdminReturn";

import { API_URL } from "../../../../config";

import {

  normalizeCourseContenido,

} from "../../../../utils/normalizeCourseShape";

import {

  buildAdminCoursePreviewStudentValue,

  buildAdminPreviewCourseShape,

} from "../../../../utils/buildAdminCoursePreviewStudentValue";

import { StudentContext } from "../../../../context/StudentContext";

import TopicViewer from "../../../../components/TopicViewer/TopicViewer";

import AdminCoursePreviewStudentSidebar from "../../../../components/AdminCoursePreviewStudentSidebar";
import CourseDescriptionContent from "../../../../components/CourseDescriptionContent";
import { getCourseDescriptionPlainTextLength } from "../../../../utils/courseDescriptionHtml";

import Icon from "../../../../components/Icon/Icon";

import { formatCourseDurationLabel } from "../../../../utils/formatCourseDurationLabel";

import "../../../Temario.css";

import "./VistaCursosAdmin.css";



const CAMPUS_DESC_THRESHOLD = 420;



function pestanasFromCurso(pestanasCurso, contenidoNorm) {

  const fromTabs = Array.isArray(pestanasCurso)

    ? pestanasCurso.map((p) => (typeof p === "string" ? p.trim() : "")).filter(Boolean)

    : [];

  if (fromTabs.length > 0) return fromTabs;

  return Object.keys(contenidoNorm || {}).filter((key) => key.trim());

}



const VistaCursosAdmin = () => {

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const { id } = useParams();

  const [curso, setCurso] = useState(null);

  const [cargando, setCargando] = useState(true);

  const [errorCarga, setErrorCarga] = useState(null);

  const [pestanaActiva, setPestanaActiva] = useState("");

  const [descExpanded, setDescExpanded] = useState(false);

  const viewerRef = useRef(null);



  const handleVolver = useCallback(() => {

    const returnTo = searchParams.get("returnTo");

    navigate(resolveVistaCursoAdminExitPath(returnTo, id));

  }, [id, navigate, searchParams]);



  useEffect(() => {

    if (id == null || String(id).trim().length === 0) {

      setCurso(null);

      setErrorCarga("Identificador de curso no válido.");

      setCargando(false);

      return;

    }

    const controller = new AbortController();

    let cancelled = false;

    setCargando(true);

    setErrorCarga(null);

    setCurso(null);

    setDescExpanded(false);



    const obtenerCurso = async () => {

      try {

        const res = await fetch(`${API_URL}/api/admin/cursos/${id}`, {

          credentials: "include",

          signal: controller.signal,

        });

        const data = await res.json().catch(() => ({}));

        if (cancelled) return;

        if (!res.ok) {

          setCurso(null);

          setErrorCarga(

            typeof data?.error === "string" && data.error.trim()

              ? data.error

              : `No se pudo cargar el curso (${res.status}).`,

          );

          return;

        }

        setCurso(data);

      } catch (error) {

        if (cancelled) return;

        if (error?.name === "AbortError") return;

        console.error("Error al cargar el curso:", error);

        setCurso(null);

        setErrorCarga("Error de conexión al cargar el curso.");

      } finally {

        if (!cancelled) setCargando(false);

      }

    };

    obtenerCurso();

    return () => {

      cancelled = true;

      controller.abort();

    };

  }, [id]);



  const contenidoNorm = useMemo(() => normalizeCourseContenido(curso?.contenido), [curso?.contenido]);

  const pestanasLista = useMemo(

    () => pestanasFromCurso(curso?.pestanasCurso, contenidoNorm),

    [curso?.pestanasCurso, contenidoNorm],

  );



  const previewCourse = useMemo(() => {

    if (!curso) return null;

    const pestanasCurso = pestanasLista.length > 0 ? pestanasLista : ["Programa Formativo"];

    const contenido = buildAdminPreviewCourseShape(contenidoNorm, pestanasCurso);

    return {

      _id: curso._id,

      id: curso._id,

      titulo: curso.titulo ?? "",

      descripcion: curso.descripcion ?? "",

      imagen: curso.imagen ?? "",

      pestanasCurso,

      contenido,

      userProgress: [],

      testResults: [],

      tests: curso.tests,

    };

  }, [contenidoNorm, curso, pestanasLista]);



  const studentPreviewValue = useMemo(

    () => buildAdminCoursePreviewStudentValue({ course: previewCourse }),

    [previewCourse],

  );



  useEffect(() => {

    setPestanaActiva("");

    setDescExpanded(false);

  }, [id]);



  useEffect(() => {

    if (pestanaActiva || pestanasLista.length === 0) return;

    setPestanaActiva(pestanasLista[0]);

  }, [pestanaActiva, pestanasLista]);



  if (cargando) {

    return (

      <div className="vista-cursos-admin-page">

        <div className="vista-cursos-container">Cargando curso...</div>

      </div>

    );

  }



  if (errorCarga || !curso || !previewCourse) {

    return (

      <div className="vista-cursos-admin-page">

        <div className="vista-cursos-container">

          <p>{errorCarga || "Curso no encontrado."}</p>

          <button type="button" className="botonSalir" onClick={() => navigate("/GestionCursos")}>

            Volver a gestión de cursos

          </button>

        </div>

      </div>

    );

  }



  const courseDescId = `admin-preview-desc-${curso._id}`;

  const descripcion = previewCourse.descripcion || "";
  const descripcionPlainLength = getCourseDescriptionPlainTextLength(descripcion);



  return (

    <div className="vista-cursos-admin-page">

      <div className="vista-cursos-admin-preview-banner">

        <p>Vista previa del campus del alumno</p>

        <button type="button" className="vista-cursos-admin-salir-btn" onClick={handleVolver}>

          Salir de vista previa

        </button>

      </div>



      <StudentContext.Provider value={studentPreviewValue}>

        <div className="admin-preview-student-layout">

          <AdminCoursePreviewStudentSidebar

            courseTitle={previewCourse.titulo}

            pestanas={pestanasLista}

            activePestana={pestanaActiva}

            onPestanaChange={setPestanaActiva}

          />

          <div className="admin-preview-student-main">

            <div className="cds-campus-root vista-cursos-admin-campus">

          <div className="cds-campus-layout">

            <div className="cds-campus-hero-card">

              <div className="cds-hero-main">

                <span className="cds-badge-active">Curso Activo</span>

                <h2 className="cds-hero-title">{previewCourse.titulo}</h2>

                {descripcion ? (

                  <>

                    <CourseDescriptionContent

                      id={courseDescId}

                      html={descripcion}

                      className="cds-hero-desc"

                      clamped={descripcionPlainLength > CAMPUS_DESC_THRESHOLD && !descExpanded}

                    />

                    {descripcionPlainLength > CAMPUS_DESC_THRESHOLD ? (

                      <button

                        type="button"

                        className="cds-hero-desc-toggle"

                        onClick={() => setDescExpanded((prev) => !prev)}

                        aria-expanded={descExpanded}

                        aria-controls={courseDescId}

                      >

                        {descExpanded ? "Ver menos" : "Ver más"}

                      </button>

                    ) : null}

                  </>

                ) : null}

                {curso.duracion ? (

                  <p className="vista-cursos-admin-duration">

                    Duración: {formatCourseDurationLabel(curso.duracion)}

                  </p>

                ) : null}

                <button

                  type="button"

                  className="cds-btn-continue"

                  onClick={() => {

                    if (viewerRef.current) {

                      viewerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

                    }

                  }}

                >

                  <Icon name="play" className="cds-campus-icon" /> Continuar Estudio

                </button>

              </div>



              <div className="cds-hero-progress-box">

                <div className="cds-progress-top">

                  <Icon name="award" className="cds-campus-icon cds-award-icon" />

                  <span className="cds-progress-percent">0%</span>

                </div>

                <p className="cds-progress-label">Progreso Real</p>

                <div className="cds-progress-bar-bg">

                  <div className="cds-progress-bar-fill" style={{ width: "0%" }} />

                </div>

                <div className="cds-progress-stats">

                  <span>0 de 0 temas dominados</span>

                </div>

              </div>

            </div>



            <div className="cds-campus-viewer-wrapper" ref={viewerRef}>

              <TopicViewer

                curso={previewCourse}

                previewMode

                activePestana={pestanaActiva}

                onPestanaChange={setPestanaActiva}

              />

            </div>

          </div>

            </div>

          </div>

        </div>

      </StudentContext.Provider>

    </div>

  );

};



export default VistaCursosAdmin;

